// 日付関連のユーティリティ関数

/**
 * ローカルタイムゾーンで今日の日付文字列を取得（YYYY-MM-DD形式）
 */
export const getLocalDateString = (date: Date = new Date()): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * ローカルタイムゾーンで現在時刻文字列を取得（HH:MM形式）
 */
export const getLocalTimeString = (date: Date = new Date()): string => {
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${hours}:${minutes}`;
};

/**
 * ローカルタイムゾーンで日時文字列を取得（ISO形式風だがローカル時刻）
 */
export const getLocalDateTimeString = (date: Date = new Date()): string => {
  return `${getLocalDateString(date)}T${getLocalTimeString(date)}:${String(date.getSeconds()).padStart(2, '0')}.${String(date.getMilliseconds()).padStart(3, '0')}`;
};

/**
 * YYYY-MM-DD形式の文字列をDateオブジェクトに変換（ローカルタイムゾーン）
 */
export const parseLocalDateString = (dateString: string): Date => {
  const [year, month, day] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day);
};

/**
 * 月曜日を週の始まりとして、その週の月曜日の日付を取得
 */
export const getWeekStartMonday = (date: Date): Date => {
  const d = new Date(date);
  const day = d.getDay();
  const diff = d.getDate() - day + (day === 0 ? -6 : 1); // 日曜日の場合は-6、それ以外は月曜日までの差分
  const monday = new Date(d.setDate(diff));
  monday.setHours(0, 0, 0, 0);
  return monday;
};